import { Task } from 'taskarian';
import GroupStore from '.';
import { callApi } from '../Appy';
import { findLinkT } from '../LinkyLinky';
import { Link } from '../Resource/Types';
import { fromNullableT } from '../TaskExt';
import { groupNewResourceDecoder } from './Decoders';
import { GroupError, GroupNewResource } from './Types';

const loadNewGroupResource = (links: ReadonlyArray<Link>) =>
  Task.succeed<GroupError, ReadonlyArray<Link>>(links)
    .andThen(findLinkT('new'))
    .andThen(callApi(groupNewResourceDecoder, {}));

const loadNewTemplate = (args: { resource: GroupNewResource }) =>
  fromNullableT(args.resource.templates.self);

export const loading = (store: GroupStore) =>
  Task.succeed<GroupError, {}>({})
    .assign('resource', loadNewGroupResource(store.groupsStore.links))
    .assign('template', loadNewTemplate)
    .fork(store.loadError, store.newing);
